/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: eprivacy
 * Version: 7.3.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
import AppList from './app-list';
var pickApps = function pickApps(apps, names) {
  return names.map(function (name) {
    return apps.find(function (app) {
      return app.name === name;
    });
  });
};
var CategorizedAppList = function CategorizedAppList(_ref) {
  var t = _ref.t,
    ns = _ref.ns,
    categories = _ref.categories,
    apps = _ref.apps,
    consents = _ref.consents,
    onToggle = _ref.onToggle;
  return /*#__PURE__*/React.createElement("ul", {
    className: ns('CategorizedAppList')
  }, categories.map(function (_ref2) {
    var name = _ref2.name,
      appNames = _ref2.apps;
    return /*#__PURE__*/React.createElement("li", {
      className: ns('CategorizedAppList-item') + ' ' + ns('CategorizedAppList-item') + '-' + name
    }, /*#__PURE__*/React.createElement("div", {
      className: ns('CategorizedAppList-header')
    }, /*#__PURE__*/React.createElement("h2", {
      className: ns('CategorizedAppList-title'),
      dangerouslySetInnerHTML: {
        __html: t([name, 'title'])
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: ns('CategorizedAppList-details'),
      dangerouslySetInnerHTML: {
        __html: t([name, 'details'])
      }
    }), /*#__PURE__*/React.createElement("p", {
      className: ns('CategorizedAppList-description'),
      dangerouslySetInnerHTML: {
        __html: t([name, 'description'])
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: ns('CategorizedAppList-apps')
    }, /*#__PURE__*/React.createElement(AppList, {
      t: t,
      ns: ns,
      apps: pickApps(apps, appNames),
      consents: consents,
      onToggle: onToggle
    })));
  }));
};
export default CategorizedAppList;